import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { GenericValidationsService } from 'src/app/Service/generic-validations.service';
import { SevaProfileService } from 'src/app/Service/seva-profile.service';
import { CONSTANTS } from 'src/Core/Constant';
import { environment } from 'src/environments/environment';
import { DocumentUploadConfig } from '../../addendum-document-upload/addendum-document-upload.component';
import { TranslationService } from 'src/app/Service/translation.service';

@Component({
  selector: 'app-pth-contemplation',
  templateUrl: './pth-contemplation.component.html',
  styleUrls: ['./pth-contemplation.component.scss']
})
export class PthContemplationComponent {
  @Output() formGroupChange = new EventEmitter<FormGroup>();
  @Output() nextStep = new EventEmitter<void>();
  @Output() previous = new EventEmitter<void>();
  @Input() isPreviewMode: boolean = false; // Flag to determine behavior
  @Input() applicantData: any; // Accept data from parent component

  // Document upload properties
  DocumentType = CONSTANTS.DocumentType;
  documents: any[] = [];
  isJsonShow = environment.isJsonShow;  // Set isJsonShow from the environment


  siddhaYogaRetreatForm!: FormGroup;
  submitted = false;
  documentSectionSubmitted = false; // Track document section validation
  SaveMode = CONSTANTS.SAVE_MODE;
  isEditable: boolean = true; // Flag to track if the form is editable
  // Letter count properties
  characterCounts = {
    TeachingsPracticeInDetails: 0,
    WebsitePracticeInDetails: 0,
    PracticeBenefits1: 0,
    PracticeBenefits2: 0,
    MeditationPracticesDetails: 0,
    MeditationPracticesImpact: 0,
    Purpose: 0
  };

  constructor(
    private activatedRoute: ActivatedRoute, private router: Router,
     private fb: FormBuilder, private toastr: ToastrService,
      private api: SevaProfileService,
       public genericValidations: GenericValidationsService,
       private translationService: TranslationService) {
  }

  // Letter counting methods
  countLetters(text: string): number {
    if (!text) return 0;
    return text.length;
  }

  updateLetterCount(fieldName: string, value: string): void {
    this.characterCounts[fieldName as keyof typeof this.characterCounts] = this.countLetters(value);
  }

  getCharacterCount(fieldName: string): number {
    return this.characterCounts[fieldName as keyof typeof this.characterCounts];
  }
  ngOnInit(): void {
    if (!this.isPreviewMode) {
      this.initializeForm();
      this.getApplicantData();
      // Note: Document loading is now handled by the generic addendum-document-upload component
    }
  }



  ngOnChanges(changes: SimpleChanges): void {
    if (changes['applicantData'] && this.applicantData) {

      this.initializeForm();
      this.siddhaYogaRetreatForm.patchValue(this.applicantData);
      this.siddhaYogaRetreatForm.disable();
      // Initialize word counts for preview mode
      this.updateLetterCount('TeachingsPracticeInDetails', this.applicantData.TeachingsPracticeInDetails || '');
      this.updateLetterCount('WebsitePracticeInDetails', this.applicantData.WebsitePracticeInDetails || '');
      this.updateLetterCount('PracticeBenefits1', this.applicantData.PracticeBenefits1 || '');
      this.updateLetterCount('PracticeBenefits2', this.applicantData.PracticeBenefits2 || '');
      this.updateLetterCount('MeditationPracticesDetails', this.applicantData.MeditationPracticesDetails || '');
      this.updateLetterCount('MeditationPracticesImpact', this.applicantData.MeditationPracticesImpact || '');
      this.updateLetterCount('Purpose', this.applicantData.Purpose || '');
    }
  }



  initializeForm() {
    this.siddhaYogaRetreatForm = this.fb.group({

      SubmissionMode: ['', Validators.required],
      SaveMode: ['', Validators.required],


    


      TeachingsPracticeInDetails: ['', [Validators.required, Validators.minLength(100), Validators.maxLength(5000)]],
      WebsitePracticeInDetails: ['', [Validators.required, Validators.minLength(100), Validators.maxLength(5000)]],
      
      
      
      PracticeBenefits1: ['', [Validators.required, Validators.minLength(100), Validators.maxLength(5000)]],
      PracticeBenefits2: ['', [Validators.required, Validators.minLength(100), Validators.maxLength(5000)]],


      MeditationPracticesDetails: ['', [Validators.required, Validators.minLength(100), Validators.maxLength(5000)]],
      MeditationPracticesImpact: ['', [Validators.required, Validators.minLength(100), Validators.maxLength(5000)]],

      Purpose: ['', [Validators.required, Validators.minLength(100), Validators.maxLength(5000)]],
    });

    this.formGroupChange.emit(this.siddhaYogaRetreatForm);
  }


  onSubmit(Mode: number): void {
   


    
    this.siddhaYogaRetreatForm.patchValue({
      SaveMode: Mode
    })
 

    let submissionType = this.siddhaYogaRetreatForm.get("SubmissionMode")?.value

    if (submissionType == 'file') {
      // Validate document section
      this.documentSectionSubmitted = true;
      
      if (!this.documents || this.documents.length === 0) {
        this.toastr.error('Please upload at least one document before proceeding.');
        return;
      } else {
        const cleanedValues = this.genericValidations.removeWhitespaceFromValues(this.siddhaYogaRetreatForm.value);
        this.addUpdate(cleanedValues, Mode);
      }
    }

    else {

      if (!this.siddhaYogaRetreatForm.valid && Mode == this.SaveMode.SAVE) {
        this.submitted = true;
        this.siddhaYogaRetreatForm.markAllAsTouched();
        this.toastr.warning('Please complete all required fields before submitting.');
        return
      }
      const cleanedValues = this.genericValidations.removeWhitespaceFromValues(this.siddhaYogaRetreatForm.value);
      this.addUpdate(cleanedValues, Mode);
    }
  }

  addUpdate(reqBoby: any, Mode: number) {
    this.api.apiCall('AddendumPTH/SavePTHAddendum', 'POST', reqBoby).subscribe((response: any) => {
      this.toastr.success(response?.Message);
      if (Mode == this.SaveMode.SAVE) {
        this.nextStep.emit();
      } else if (Mode == this.SaveMode.DRAFT) {
        this.getApplicantData();
      }
    });
  }



  getApplicantData() {
    this.api.apiCall('AddendumPTH/GetPTHAddendum', 'GET').subscribe((response: any) => {
      if (response.Data && Object.keys(response.Data).length > 0) {
        this.genericValidations.setProgressPercentage(response.Data.CompletionPercentage); // Example: Set progress to 50%
        
        // Store IsEditable flag from response
        this.isEditable = response.Data.IsEditable !== false; // Default to true if not provided

        // Disable form if not editable
        if (!this.isEditable) {
          this.siddhaYogaRetreatForm.disable();
        } else {
          this.siddhaYogaRetreatForm.enable();
        }
        
        this.siddhaYogaRetreatForm.patchValue(response.Data);
        // Initialize word counts for existing data
        this.updateLetterCount('TeachingsPracticeInDetails', response.Data.TeachingsPracticeInDetails || '');
        this.updateLetterCount('WebsitePracticeInDetails', response.Data.WebsitePracticeInDetails || '');
        this.updateLetterCount('PracticeBenefits1', response.Data.PracticeBenefits1 || '');
        this.updateLetterCount('PracticeBenefits2', response.Data.PracticeBenefits2 || '');
        this.updateLetterCount('MeditationPracticesDetails', response.Data.MeditationPracticesDetails || '');
        this.updateLetterCount('MeditationPracticesImpact', response.Data.MeditationPracticesImpact || '');
        this.updateLetterCount('Purpose', response.Data.Purpose || '');
      }
    })
  }


    

  goToBack(): void {
    this.previous.emit();
  }



  // Event handlers for generic document upload component
  onDocumentsChange(documents: any[]): void {
    this.documents = documents;
  }


  onValidationChange(isValid: boolean): void {
    console.log('Document validation state:', isValid);
  }


   // Document upload configuration
   documentUploadConfig: DocumentUploadConfig = {
    title: 'PTH Document Upload',
    description: 'Please upload your PTH Document. Supported formats: PDF, JPEG, PNG. Maximum file size: 5MB.',
    uploadButtonText: 'Upload PTH Document',
    documentTypeLabel: 'PTH Document',
    acceptedFormats: '.pdf,.jpg,.jpeg,.png',
    validationErrorTitle: 'Document Required',
    validationErrorMessage: 'Please upload at least one document before proceeding to the next step.',
    documentType: CONSTANTS.DocumentType.PTHDoc,
    maxFileSize: 5 * 1024 * 1024, // 5MB in bytes
    allowedFormats: ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'],
    endpoints: {
      upload: 'FileHandler/UploadFile',
      getAll: 'FileHandler/GetAllDocuments',
      delete: 'FileHandler/DeleteFileById?id=',
      saveParentAddendum: 'AddendumPTH/SavePthContemplation' // added for parent save mode

    }
  };

  // Translations
  getTranslation(key: string): string {
    return this.translationService.getTranslation(key);
  }
}
